$(document).ready(function() {
  var listMenu = $('.list-menu');
  var lavaLamp = $('<div class="lava-lamp"></div>').appendTo(listMenu);

  // Check if the active menu item exists in the menu
  var activeMenuItem = $('.header__active-menu-item');

  function updateLavaLamp(element) {
    if (listMenu.length === 0 || element.length === 0) {
      // Exit if either the menu or the active menu item is not found
      return;
    }

    var leftOffset = element.position().left - listMenu.position().left;

    if (element.is(':hover')) {
      // No left offset when hovered
      leftOffset += 20;
    }

    var width = element.width();
    lavaLamp.css({ left: leftOffset, width: width });
  }

  // Default to specific left and width values on page load
  lavaLamp.css({ left: 20, width: 45.8281 });

  // If active menu item exists, set the initial position
  if (activeMenuItem.length > 0) {
    updateLavaLamp(activeMenuItem);
  }

  $('.list-menu a').hover(
    function() {
      var currentItem = $(this);
      updateLavaLamp(currentItem);
    },
    function() {
      if (activeMenuItem.length > 0) {
        updateLavaLamp(activeMenuItem);
      }
    }
  );
});